import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { Intercompany } from '@/features/insights/Intercompany';
import { MobileIntercompany } from '@/features/insights/mobile/MobileIntercompany';

export const Route = createFileRoute('/_app/intercompany')({ component: IntercompanyRoute });

/** Selettore: intercompany mobile (MaeDesign) vs hub desktop a tabelle. */
function IntercompanyRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileIntercompany /> : <Intercompany />;
}
